import { makeStyles } from '@mui/styles';
import { COLOR_GRAY_70, COLOR_GRAY_90, COLOR_PINK, COLOR_PURPLE } from 'styles/variables/colors';

export const useStyles = makeStyles((theme) => ({
  grayColor: {
    color: COLOR_GRAY_70,
    fontFamily: 'Lato',
    textAlign: 'left',
  },
  title: {
    fontSize: 34,
    color: COLOR_PURPLE,
    textAlign: 'center',
  },
  secondaryColor: {
    color: COLOR_PINK,
    fontFamily: 'Lato',
    textAlign: 'left',
    display: 'flex',
    alignItems: 'baseline',
    gap: 4,
  },
  switchBox: {
    borderRadius: 8,
    border: '1px solid #EAECF0',
    background: '#F9FAFB',
    padding: theme.spacing(1),
    margin: '0 auto',
    display: 'flex',
    gap: theme.spacing(1),
    width: 'auto',
    minWidth: 'fit-content',
    '& span': {
      fontWeight: 700,
      fontFamily: 'Lato',
    },
  },
  switch: {
    color: COLOR_GRAY_70,
    fontFamily: 'Lato',
    fontSize: 16,
    fontWeight: 600,
    borderRadius: 6,
    padding: theme.spacing(1.25, 1.75),
    cursor: 'pointer',
    textTransform: 'initial',

    '&:hover': {
      boxShadow: '0px 1px 2px 0px rgba(16, 24, 40, 0.06), 0px 1px 3px 0px rgba(16, 24, 40, 0.10)',
      background: '#fff',
    },
  },
  activeSwitch: {
    boxShadow: '0px 1px 2px 0px rgba(16, 24, 40, 0.06), 0px 1px 3px 0px rgba(16, 24, 40, 0.10)',
    backgroundColor: '#FFF',
  },
  activeSwitchPink: {
    color: COLOR_PINK,
  },
  activeSwitchPurple: {
    color: COLOR_PURPLE,
  },
  month: {
    fontSize: 18,
  },
  priceCard: {
    marginBottom: theme.spacing(4),
    borderRadius: 16,
    backgroundColor: theme.palette.common.white,
    boxShadow: '0px 4px 6px -2px rgba(16, 24, 40, 0.03), 0px 12px 16px -4px rgba(16, 24, 40, 0.08)',
    border: '1px solid #E0E0E0',
    '& p, & > span': {
      fontFamily: 'Lato',
    },
    '& a': {
      marginTop: theme.spacing(1),
      marginBottom: theme.spacing(2),
    },

    [theme.breakpoints.up('md')]: {
      marginBottom: 0,
    },
  },
  priceCardActiveSecondary: {
    position: 'relative',
    border: `1px solid ${COLOR_PINK}`,
    boxShadow: '0px 4px 6px -2px rgba(16, 24, 40, 0.03), 0px 12px 16px -4px rgba(16, 24, 40, 0.08)',
  },
  cardTitle: {
    color: COLOR_GRAY_70,
    fontSize: 18,
    fontWeight: 700,
    fontFamily: 'Lato',
  },
  cardTitleEmphasis: {
    color: COLOR_PINK,
  },
  tagMostPopular: {
    display: 'block',
    color: COLOR_PINK,
    fontSize: 14,
    fontWeight: 700,
    fontFamily: 'Lato',
    background: '#FDF2FA',
    padding: '2px 8px',
    border: '1px solid #FCCEEE',
    borderRadius: 6,
    width: 'fit-content',
  },
  cardTitlePrice: {
    color: COLOR_GRAY_90,
    fontFamily: 'Lato',
    fontSize: 40,
    fontWeight: 700,
    textAlign: 'left',
  },
  cardSubtitleMain: {
    color: COLOR_GRAY_70,
    fontFamily: 'Lato',
    fontSize: 16,
    textAlign: 'left',
    display: 'block',
    marginTop: theme.spacing(3),
    marginBottom: theme.spacing(3),
  },
  titleListCard: {
    color: COLOR_GRAY_90,
    fontFamily: 'Lato',
    fontSize: 18,
    fontWeight: 700,
    paddingTop: theme.spacing(3),
    paddingBottom: theme.spacing(2),
    borderTop: '1px solid #BDBDBD',

    '& span': {
      fontSize: 16,
      fontWeight: 400,
      display: 'block',
      color: COLOR_GRAY_70,
    },
  },
  itemList: {
    color: COLOR_GRAY_70,
    fontSize: 16,
    marginBottom: theme.spacing(1.5),
    display: 'flex',
    alignItems: 'flex-start',
    gap: 8,

    '& > span': {
      width: '87%',
    },
  },
  titleListCardEmphasis: {
    color: COLOR_PINK,
    borderColor: COLOR_PINK,
  },
  list: {
    paddingInlineStart: '30px',
    color: theme.palette.grey[300],

    '& li': {
      marginBottom: theme.spacing(1.5),
    },

    '& span': {
      fontSize: theme.typography.body2.fontSize,
      color: theme.palette.text.primary,
    },
  },
  buttonLink: {
    color: COLOR_PURPLE,
    fontSize: 14,
    textTransform: 'none',
    fontFamily: 'Lato',
    marginBottom: 0,
    top: 8,
    position: 'relative',

    '&:hover': {
      color: COLOR_PURPLE,
      textDecoration: 'underline',
      backgroundColor: 'transparent',
    },
  },
  discountText: {
    color: COLOR_GRAY_70,
    fontSize: 16,
    fontFamily: 'Lato',
  },
  totalPriceYear: {
    color: COLOR_GRAY_70,
    fontSize: 11,
    lineHeight: '19px',
    textAlign: 'left',
  },
  textBannerLocale: {
    color: theme.palette.common.white,
    fontSize: 23,

    '& div': {
      display: 'inline',
      textDecoration: 'underline',
    },

    '& span': {
      fontSize: 40,
      fontWeight: 900,
    },
  },
}));
